import { NetworkService } from '../../../../services/networkService';
export const fetchTruBrokerLogDetails = (page, userId) => {
  const response = NetworkService.get(`/api/users/${userId}/trubroker/tru_point_activities?page=${page || 1}`);
  return response;
};
